module.exports = __webpack_public_path__ + "img/me.27e44ef9.jpg";